export function groupClassFinalExamVariants(variants) {
  const classExamMap = {};

  variants.forEach((variant) => {
    if (variant.parentExamId) {
      const pId = variant.parentExamId;

      if (!classExamMap[pId]) {
        classExamMap[pId] = { parent: null, children: [] };
      }

      classExamMap[pId].children.push(variant);
    } else {
      const vId = variant.id;

      if (!classExamMap[vId]) {
        classExamMap[vId] = { parent: null, children: [] };
      }

      classExamMap[vId].parent = variant;
    }
  });

  return Object.values(classExamMap);
}

export function groupStudentFinalExamVariants(variants) {
  const studentExamMap = {};

  variants.forEach((variant) => {
    if (variant.parentId) {
      const pId = variant.parentId;

      if (!studentExamMap[pId]) {
        studentExamMap[pId] = { parent: null, children: [] };
      }

      studentExamMap[pId].children.push(variant);

      if (!studentExamMap[pId].parent) {
        const parentVariant = {
          variantId: variant.parentId,
          name: variant.parentName,
          isDerivedParent: true,
        };

        studentExamMap[pId].parent = parentVariant;
      }
    } else {
      const vId = variant.variantId;

      if (!studentExamMap[vId]) {
        studentExamMap[vId] = { parent: null, children: [] };
      }

      studentExamMap[vId].parent = variant;
    }
  });

  return Object.values(studentExamMap);
}
